import React, {FC, useContext} from 'react'
import {HotelCardContext} from 'components/HotelCardContext'
import {SelectedElement} from 'utils/selectedElement'

import {Location} from '@vio/shared/src/search/Location'

interface Props {
  placeName: string
}

export const LocationDetails: FC<Props> = ({placeName}) => {
  const {hotelId} = useContext(HotelCardContext)

  return (
    <div>
      <div data-id={SelectedElement.Location}>
        <Location place={placeName} hotelId={hotelId} />
      </div>
    </div>
  )
}
